<template>
	<div class="feedback_box">
		<div class="w-100 text-center" style="display: flex; justify-content: center; align-items: center; height: 6%;">
			<div class="feedback_title">
				ОТЗЫВЫ
			</div>
		</div>
		<div class="feedback_card_box">
			<div class="shadow_left"></div>
			<carousel v-if="screenWidth <= 575"
				:per-page="1"
				:mouse-drag="true"
				:navigationEnabled="false"
			>
				<slide  :key="idx" v-for="(star, idx) in stars" style="padding: 0.5em;">
					<div class="star_card">
						<div class="star_card_img">
							<img :src="star.img" alt=""/>
						</div>
						<div class="star_card_name">
							{{star.name}}
						</div>
						<div class="star_card_text">
							{{star.text}}
						</div>
					</div>
				</slide>
			</carousel>
			<carousel v-else-if="screenWidth > 575 && screenWidth < 768"
				:per-page="2.5"
				:mouse-drag="true"
				:navigationEnabled="false"
				:scrollPerPage="false"
				:paginationEnabled="false"

			>
				<slide  :key="idx" v-for="(star, idx) in stars" style="padding: 0.5em;">
					<div class="star_card">
						<div class="star_card_img">
							<img :src="star.img" style="object-fit: cover; width: 100%; height: auto;" alt=""/>
						</div>
						<div class="star_card_name">
							{{star.name}}
						</div>
						<div class="star_card_text">
							{{star.text}}
						</div>
					</div>
				</slide>
			</carousel>
			<carousel v-else-if="screenWidth > 767"
				:per-page="4.5"
				:mouse-drag="true"
				:navigationEnabled="false"
				:scrollPerPage="false"
				:paginationEnabled="false"

			>
				<slide  :key="idx" v-for="(star, idx) in stars" style="padding: 0.5em;">
					<div class="star_card">
						<div class="star_card_img">
							<img :src="star.img" alt=""/>
						</div>
						<div class="star_card_name">
							{{star.name}}
						</div>
						<div class="star_card_text">
							{{star.text}}
						</div>
					</div>
				</slide>
			</carousel>
			<div class="shadow_right"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "FeedbackComponent",
	data() {
		return {
			stars: [
				{
					id: 1,
					name: '',
					img: require('../assets/img/feedback/photo_2024-09-02_19-39-38.jpg'),
					text: 'Незабываемый отдых в капсульном домике загородного комплекса 😍 Уникальный и стильный домик, который предоставил мне удивительный опыт близкого контакта с природой. Просыпаться под звездным небом и наслаждаться окружающей природой через панорамное окно было восхитительно. Внутри все удобства для комфортного проживания. Отличный выбор для тех, кто ищет необычный и запоминающийся отдых. Спасибо за такой удивительный опыт!'
				},
				{
					id: 2,
					name: '',
					img: require('../assets/img/feedback/photo_2024-09-02_19-40-11.jpg'),
					text: 'Прекрасный отдых в шале-коттедже загородного комплекса! Уютный и стильный коттедж, великолепный вид на пляж. Внутри все продумано до мелочей, есть все необходимое для комфортного проживания. Отличное место для отдыха с семьей или друзьями. Благодарю за гостеприимство и незабываемые впечатления'
				},
				{
					id: 3,
					name: '',
					img: require('../assets/img/feedback/photo_2024-09-02_19-40-16.jpg'),
					text: 'Я испытала самые удивительные и искренние эмоции. На прошлой неделе мы с семьей приехали в загородный комплекс на шоу-программу “Морская история”. После программы мы приобрели билет на плаванье с дельфинами. Контакт в воде с морским обитателем у нас вызвало бурю положительных эмоций. Еще неделю я с восторгом делилась с близким своми впечатлениями. Спасибо Вам большое, за возможность испытать новые эмоции и почувствовать себя еще счастливее. Вернусь к вам еще раз со своими друзьями ❤️'
				},
				{
					id: 4,
					name: '',
					img: require('../assets/img/feedback/photo_2024-09-02_19-40-21.jpg'),
					text: 'Идеальное место для семейного отдыха. Для детей есть все необходимые развлечение 3 детских зоны, аниматоры, возможность приобрести игрушку и сувенир в магазине. Дети остались в полном восторге. Но и мы родители, тоже полностью восстановились в спа-комплексе. Программа Relax массажа великолепная, мастер лучший в своем деле. Все было отлично организовано, персонал дружелюбный и отзывчивый. Мы Ваши фанаты теперь, приедем еще и не раз!'
				},

			]
		}
	},
	computed: {
		screenWidth() {
			return this.$store.state.screenWidth;
		}
	},
}
</script>

<style scoped>
.feedback_box {
	position: relative;
	background-color: #161616;
	min-height: 60vh;
	width: 100%;
}

.feedback_title {
	color: white;
	position: absolute;
	top: 0;
	margin: 0 auto;
	font-weight: 200;
	letter-spacing: 0.2em;
	font-size: 3em;
	padding: 0.5em 2em;
	width: 60%;
	/*height: 100%;*/
	background-color: #1B1A1A;
	border-radius: 10px 10px;
	padding-bottom: 4em;
}
.feedback_card_box {
	/*background-color: #212121;*/

	width: 100%;
	overflow: hidden;
	display: flex;
    flex-flow: row nowrap;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    margin: 5em 0;
	position: relative;

}

.star_card {
	background-color: #242424;
	padding: 1em;
	color: #A6CBD3;
	font-weight: 200;
	border-radius: 10px;
}

.star_card_img {
	border-radius: 1000px;
	overflow: hidden;
	width: 70px;
	height: 70px;
}

.star_card_img img {
	width: 70px;
	height: 70px;
	object-fit: cover;
}

.star_card_name {
	padding: 1em 0em;
}
.star_card_text {
	font-size: 0.7em;
}


.feedback_card_box > div {
	width: 100%;
}

.feedback_card_box > article {
	margin: 1em;

}


.shadow_left {
	position: absolute;
	width: 10% !important;
	left: 0;
	height: 100%;
	background: linear-gradient(90deg, #161616 3.59%, rgba(22, 22, 22, 0.8) 45.77%, rgba(22, 22, 22, 0) 96.3%);
	z-index: 10;
}
.shadow_right {
	position: absolute;
	width: 10% !important;
	right: 0;
	height: 100%;
	background: linear-gradient(-90deg, #161616 3.59%, rgba(22, 22, 22, 0.8) 45.77%, rgba(22, 22, 22, 0) 96.3%);
	z-index: 10;
}

@media (max-width: 575px) {
	.feedback_title {
		color: white;
		position: relative;
		top: 0;
		margin: 0 auto;
		font-weight: 200;
		letter-spacing: 0.2em;
		font-size: 2em;
		background-color: transparent;
		border-radius: 10px 10px;
		padding: 0;
	}
	.star_card {
		background-color: #242424;
		padding: 2em;
		color: #A6CBD3;
		font-weight: 200;
		border-radius: 10px;
		width: 90%;
		margin: 0 auto;
	}
	.feedback_box {
		padding-bottom: 3em;
	}
	.star_card_name {
		font-size: 1.2em;
	}
	.star_card_text {
		font-size: 0.9em;
	}
}

</style>